import { HOMEPAGE_HEADER_V2, VARIANT_A, VARIANT_B } from '../../config/ab/experiments';

export const isVariantA = ({ ab }) => {
    return ab[HOMEPAGE_HEADER_V2.experimentId] === VARIANT_A;
};

export const isVariantB = ({ ab }) => {
    return ab[HOMEPAGE_HEADER_V2.experimentId] === VARIANT_B;
};
